<template>
  <div class="page-wrap">
    <Header></Header>

    <div class="apply-area flex-r-center">
      <div class="card-width">
        <el-card>
          <div slot="header" class="card-wrap flex-center-center fz24">
            <div
                class="tab-item tab-item-active"
            >
              备案信息录入
            </div>
          </div>

          <div class="single-apply-area">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="150px"
                class="demo-ruleForm"
                v-loading="loading"
            >
              <div class="upload-image">
                <div class="fz14 top-text">
                  <div class="mb5" style="width: 100px">
                    <span style="color: red" class="mr5">*</span>上传材料：
                  </div>
                  <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
                  <div class="fc-407FFF pointer" @click="downAuth">下载授权书</div>
                </div>

                <el-form-item label-width="0px" prop="businessLicenseId">
                  <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>
                  <el-upload
                      ref="businessLicenseId"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 2)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('businessLicenseId')">

                      <img class="image-card" v-if="imageLicenseId" :src="imageLicenseId" alt/>
                      <img
                          class="icon-check"
                          v-if="imageLicenseId"
                          @click.stop="checkImage('license')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img
                          v-if="!imageLicenseId"
                          src="@/assets/login/image-card-official.png"
                          alt
                      />
                      <span v-if="!imageLicenseId" class="fz14 fc9">上传单位营业执照</span>
                    </div>

                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="legalPersonIdCardFront">
                  <el-input style="display: none" v-model="ruleForm.legalPersonIdCardFront"></el-input>
                  <el-upload
                      ref="legalPersonIdCardFront"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 0)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('legalPersonIdCardFront')">
                      <img class="image-card" v-if="imageUrlFront" :src="imageUrlFront" alt/>
                      <img
                          class="icon-check"
                          v-if="imageUrlFront"
                          @click.stop="checkImage('front')"
                          src="@/assets/login/icon-check-img.png"
                      />
                      <img v-if="!imageUrlFront" src="@/assets/login/image-card-people.png" alt/>
                      <span v-if="!imageUrlFront" class="fz14 fc9">上传法人身份证人像面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="legalPersonIdCardBack">
                  <el-input style="display: none" v-model="ruleForm.legalPersonIdCardBack"></el-input>
                  <el-upload
                      ref="legalPersonIdCardBack"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 1)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('legalPersonIdCardBack')">
                      <img class="image-card" v-if="imageUrlReserve" :src="imageUrlReserve" alt/>
                      <img
                          class="icon-check"
                          v-if="imageUrlReserve"
                          @click.stop="checkImage('reserve')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!imageUrlReserve" src="@/assets/login/image-card-emblem.png" alt/>
                      <span v-if="!imageUrlReserve" class="fz14 fc9">上传法人身份证国徽面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item label-width="0px" prop="authorisation">
                  <el-input style="display: none" v-model="ruleForm.authorisation"></el-input>
                  <el-upload
                      ref="authorisation"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 3)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('authorisation')">
                      <img class="image-card" v-if="imageAuthorization" :src="imageAuthorization" alt/>
                      <img
                          class="icon-check"
                          v-if="imageAuthorization"
                          @click.stop="checkImage('auth')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!imageAuthorization" style="width: 140px;" src="@/assets/login/image-card-auth.png"
                           alt/>
                      <span v-if="!imageAuthorization" class="fz14 fc9"
                      >上传企业授权书照片</span>
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

              <el-row>
                <el-col :span="12">
                  <el-form-item prop="orgCode" label="信用代码">
                    <el-input
                        v-model="ruleForm.orgCode"
                        placeholder="请输入信用代码"
                    >
                    </el-input>
                  </el-form-item>
                  <div class="prompt">请对比信用代码识别的准确性</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="orgName" label="企业名称">
                    <el-input
                        v-model="ruleForm.orgName"
                        placeholder="请输入企业名称"
                    ></el-input>
                  </el-form-item>
                  <div class="prompt">请对比企业名称识别的准确性</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="legalPersonName" label="法人姓名">
                    <el-input
                        v-model="ruleForm.legalPersonName"
                        placeholder="请输入法人姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="legalPersonId" label="法人身份证号">
                    <el-input
                        v-model="ruleForm.legalPersonId"
                        placeholder="请输入法人身份证号"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="legalPersonPhone" label="法人手机号码">
                    <el-input
                        type="number"
                        v-model="ruleForm.legalPersonPhone"
                        :maxlength="11"
                        placeholder="请输入手机号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="makeOrgCode" label="刻企名称">
                    <el-select v-model="ruleForm.makeOrgCode" disabled placeholder="请选择" style="width: 100%;">
                      <el-option
                          v-for="item in makeOrgData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="sealMaterial" label="印章材质">
                    <el-select v-model="ruleForm.sealMaterial" placeholder="请选择" style="width: 100%;">
                      <el-option
                          v-for="item in materialData"
                          :key="item.id"
                          :label="item.goodsName"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="sealType" label="印章类型">
                    <el-select v-model="ruleForm.sealType" multiple placeholder="请选择" style="width: 100%;">
                      <el-option
                          multiple
                          v-for="item in sealData"
                          :key="item.id"
                          :label="item.goodsName"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="金额">
                    <div style="height: 40px;width: 100%;display: flex;align-items: center;justify-content: flex-end;">
                      <span>{{ totalAmount }}元</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="consigneeAddress" label="收货地址">
                    <el-input
                        v-model="ruleForm.consigneeAddress"
                        placeholder="请输入收货地址"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="consigneeName" label="收货人">
                    <el-input
                        v-model="ruleForm.consigneeName"
                        placeholder="请输入收货人"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="consigneePhone" label="收货人电话">
                    <el-input
                        type="number"
                        v-model="ruleForm.consigneePhone"
                        :maxlength="11"
                        placeholder="请输入手机号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <div>
                <el-button class="next-button" style="margin-top: 0" type="primary" @click="submitForm('ruleForm')">
                  确认制作
                </el-button>
              </div>
            </el-form>
          </div>

        </el-card>
      </div>
    </div>

    <pay-dialog v-if="visible" ref="payRef" :pay-list.sync="payList" :visible.sync="visible"/>
    <check-example ref="checkRef"></check-example>
    <Bottom></Bottom>
  </div>
</template>

<script>

import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import CheckExample from "@/pages/register/components/CheckExample.vue";
import PayDialog from "@/pages/register/physicsSeal/components/payDialog.vue";

export default {
  name: "physicsSeal",
  components: {PayDialog, CheckExample, Bottom, Header},
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    var validCode = (rule, value, callback) => {
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (value === "") {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      imageLicenseId: "",
      imageUrlFront: "",
      imageUrlReserve: "",
      imageAuthorization: "",
      loading: false,
      rules: {
        businessLicenseId: [
          {
            required: true,
            message: "请上传企业营业执照",
            trigger: "change",
          },
        ],
        legalPersonIdCardFront: [
          {
            required: true,
            message: "请上传法人身份证人像面照片",
            trigger: "change",
          },
        ],
        legalPersonIdCardBack: [
          {
            required: true,
            message: "请上传法人身份证国徽面照片",
            trigger: "change",
          },
        ],
        authorisation: [
          {
            required: true,
            message: "请上传企业授权书照片",
            trigger: "change",
          },
        ],
        orgCode: [{required: true, validator: validCode, trigger: "blur"}],
        orgName: [
          {required: true, message: "请输入企业名称", trigger: "blur"},
        ],
        consigneeAddress: [
          {required: true, message: '收货地址不能为空', trigger: 'blur'}
        ],
        consigneeName: [
          {required: true, message: '收货人不能为空', trigger: 'blur'}
        ],
        consigneePhone: [
          {required: true, validator: validPhone, trigger: "blur"}
        ],
        sealMaterial: [{required: true, message: "请选择印章材质", trigger: "blur"}],
        sealType: [{required: true, message: "请选择印章类型", trigger: "blur"}],
        makeOrgCode: [{required: true, message: "请选择刻企名称", trigger: "blur"}],
        legalPersonName: [{required: true, message: "请输入法人姓名", trigger: "blur"}],
        operatorName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        legalPersonId: [{required: true, validator: validIdCard, trigger: "blur"}],
        operatorId: [{required: true, validator: validIdCard, trigger: "blur"}],
        legalPersonPhone: [{required: true, validator: validPhone, trigger: "blur"}],
        operatorPhone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
      ruleForm: {
        makeOrgCode: '912113027746077465',
        makeOrgName: '朝阳市天隆信息印章制作有限公司',
      },
      makeOrgData: [{
        value: '912113027746077465',
        label: '朝阳市天隆信息印章制作有限公司'
      }],
      // 材料数据
      materialData: [],
      // 商品价格列表
      goodList: [],
      // 显示金额
      totalAmount: 0,
      sealData: [],
      payList: {}
    }
  },
  created() {
    let id = this.$route.params.id || null
    this.ruleForm.id = id
    this.getGoodsList()
  },
  watch: {
    'ruleForm.sealMaterial': function (newValue, oldValue) {
      if (newValue) {
        this.sealData = []
        this.totalAmount = 0
        this.ruleForm.sealType = []
        this.goodList.forEach(item => {
          if (item.parentId == newValue) {
            this.sealData.push(item)
          }
        })
      } else {
        this.sealData = []
      }
    },
    'ruleForm.sealType': function (newValue, oldValue) {
      if (newValue.length > 0) {
        let ids = newValue.join(',')
        let money = 0
        this.sealData.forEach(item => {
          if (ids.includes(item.id)) {
            money = item.goodsPrice + money
          }
        })
        this.totalAmount = money
      }
    },
  },
  methods: {
    getCheckId(checkId) {
      this.$set(this.ruleForm, "checkId", checkId);
    },
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.loading = true
          let params = JSON.parse(JSON.stringify(this.ruleForm))
          params.sealType = params.sealType.join(',')
          delete params.sealMaterial;
          this.$http.post(this.$api.H5.apply, JSON.stringify(params)).then(res => {
            if (res.data.code == 200) {
              let codeImg = "data:image/png;base64," + res.data.data.payScheme;
              this.payList = {
                price: this.totalAmount,
                codeImg: codeImg,
                id: this.ruleForm.id,
                params: params,
              }
              this.visible = true
              this.loading = false
            } else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }
      });
    },
    getGoodsList() {
      this.$http.post(this.$api.H5.goods, {kqOrgCode: this.ruleForm.makeOrgCode}).then(res => {
        if (res.data.code == 200) {
          let tableData = res.data.data.physicalGoods;
          tableData.forEach(e => {
            if (e.parentId == 0) {
              this.materialData.push(e)
            } else {
              this.goodList.push(e)
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    downAuth() {
      top.window.location.href = 'https://www.lngsyz.com/app/授权书.docx'
      // window.open('https://www.lngsyz.com/app/授权书.docx')
    },
    checkExampleDia() {
      this.$refs.checkRef.show("official");
    },

    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlReserve = e.target.result;
        } else if (type == 2) {
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          this.imageAuthorization = e.target.result;
        } else if (type == 4) {
          this.imageScene = e.target.result;
        } else if (type == 5) {
          this.imageUrlOperatorFront = e.target.result;
        } else if (type == 6) {
          this.imageUrlOperatorReserve = e.target.result;
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },

    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    changeUpload(e) {
      if (e == 'legalPersonIdCardFront' || e == 'legalPersonIdCardBack' || e == 'authorisation' || e == 'businessLicenseId') {
        if (typeof GSESC === 'object') {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      } else if (e == 'scene') {
        if (this.ruleForm.legalPersonName && this.ruleForm.legalPersonId) {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }
      // this.getEncryptStr()
    },

    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      } else if (flag == "operatorFront") {
        this.srcList.push(this.imageUrlOperatorFront);
      } else if (flag == "operatorReserve") {
        this.srcList.push(this.imageUrlOperatorReserve);
      } else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      } else if (flag == "auth") {
        this.srcList.push(this.imageAuthorization);
      } else {
        this.srcList.push(this.imageScene);
      }
      this.isShowPics = true;
    },

    request(base, type) {
      let params = {
        businessCode: this.ruleForm.orgCode ? this.ruleForm.orgCode : null,
        type: '' + type,
        imageBase64: base,
      };
      if (type == 5) {
        params.type = '0';
      } else if (type == 6) {
        params.type = '1';
      }
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "legalPersonName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "legalPersonId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "legalPersonIdCardFront", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "legalPersonIdCardBack", res.data.data.imageId);
          } else if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "orgName", res.data.data.businessName);
            }

            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "orgCode", res.data.data.businessCode);
              this.$refs.ruleForm.clearValidate()
            }
          } else if (type == 3) {
            this.$set(this.ruleForm, "authorisation", res.data.data.imageId);
          } else if (type == 4) {
            this.$set(this.ruleForm, "checkId", res.data.data.imageId);
          } else if (type == 5) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "operatorName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "operatorId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "operatorIdCardFront", res.data.data.imageId);
          } else if (type == 6) {
            this.$set(this.ruleForm, "operatorIdCardBack", res.data.data.imageId);
          }
          if (res.data.data.errMsg) {
            this.$message.warning(res.data.data.errMsg);
          } else {
            this.$message.success(res.data.msg);
          }
        } else {
          this.$message.error(res.data.msg);
          if (type == 0) {
            this.imageUrlFront = "";
          } else if (type == 1) {
            this.imageUrlReserve = "";
          } else if (type == 2) {
            this.imageLicenseId = "";
          } else if (type == 3) {
            this.imageAuthorization = "";
          } else if (type == 4) {
            this.imageScene = "";
          }
        }
        this.loading = false;
      });
    },
  }
}
</script>

<style scoped lang="less">
.single-apply-area {
  margin-left: 112px;
  margin-right: 112px;

  .upload-image {
    display: flex;
    align-items: flex-start;

    .top-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
    }
  }

  .captcha-item {
    position: relative;
  }

  .get-cap {
    position: absolute;
    right: 20px;
    top: 0px;
    color: #407fff;
    cursor: pointer;
  }

  .next-button {
    width: 350px;
    font-size: 16px;
    padding: 11px 20px !important;
    margin-top: 40px;
    box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
  }
}

::v-deep .el-form-item__error {
  background-color: #ffffff;
  width: 100%
}

.prompt {
  margin-top: -28px;
  font-size: 12px;
  text-align: left;
  padding-left: 150px;
  color: #409EFF;
  margin-bottom: 11px;
}

.upload-image {
  display: flex;
  align-items: flex-start;

  .top-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
  }
}

.avatar-uploader {
  position: relative;
  width: 210px;
  height: 160px;
  margin-right: 30px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
